import { KpiType } from './kpi-type.model';

export interface InsightsSummaryDataKpi {
    kpiTypeId?: KpiType;
    kpiInitials?: string;
    kpiName?: string;
    displayOrder?: number;
    kpiValue?: number;
    kpiFormat?: string;
    kpiColour?: string;
    isDefault?: boolean;
}

export function defaultInsightsSummaryDataKpi(): InsightsSummaryDataKpi {
    return {
        kpiValue: null,
    };
}
